import React, { Component, Fragment } from "react";

class Footer extends Component {
  state = {
    data: [],
    control: null,
    loaded: false,
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.setState({
      control: this.props.control,
      loaded: true,
      data: this.props.data,
    });
  }

   clickMeAccessibilityStatement() {
    window.open('./resources/pdf/Cosmote Accessibility statement - Greek_13.07.2025-MI.pdf', '_blank');
  }

  render() {
    if (this.state.loaded) {
      return (
        <Fragment>
          <div className="footer">
            <div className="hold" style={{display:"flex", flexDirection:"column", justifyContent: "center"}}>
              <a
                className="terms open-lightbox"
                style={{ cursor: "pointer", lineHeight:"30px" }}
                // onClick={(e) => clickMeTermVat(_this)}>
              >
                Όροι &amp; Προϋποθέσεις &gt;{" "}
              </a>
              <a
                className="terms open-lightbox"
                style={{ cursor: "pointer", lineHeight:"30px" }}
                onClick={(e) => this.clickMeAccessibilityStatement()}
              >
                Δήλωση Προσβασιμότητας &gt;{" "}
              </a>
            </div>
          </div>
        </Fragment>
      );
    } else {
      return "";
    }
  }
}

export default Footer;
